import React from 'react';
import { motion } from 'framer-motion';
import { project } from '../constants';


function Projects() {
  return (
    <div className='h-screen relative flex overflow-hidden flex-col text-left md:flex-row max-w-full justify-evenly mx-auto items-center z-0'>
        <h3 className='absolute top-24 uppercase tracking-[20px] text-gray-500 text-2xl'>
           Projects
        </h3>
        <div className=' relative w-full flex overflow-x-scroll overflow-y-hidden snap-x snap-mandatory z-20 scrollbar scrollbar-thumb-[#F7AB0A]/80 scrollbar-track-gray-400/20'>
          {project.map((item, i) =>(
            <div className='w-screen flex-shrink-0 snap-center flex flex-col space-y-6 items-center justify-center p-20 md:p-44 h-screen'>
              <motion.img
               initial={{
                y:-300,
                opacity:0
               }}
               transition={{duration: 1.2}}
               whileInView={{opacity: 1, y:0}}
               viewport={{once: false}}
              src={item.imgURL} alt="" className="w-[250px] object-contain"/>
              <div className='space-y-10 px-0 md:px-10 max-w-6xl'>
                <h4 className='text-1xl md:text-2xl font-semibold text-center'>
                  <span className='underline decoration-[#F7AB0A]/50'>
                    Case Study {i +1} of {project.length}:
                  </span>{" "}
                  { item.name}
                </h4>
                <div className='text-[12px] md:text-lg text-center md:text-left'>
                  <p className=' md:flex'>{item.details}</p>
                  <a href={item.webURL} className='liveButton uppercase' target='_blank' rel="noreferrer">View Project</a>  
                </div>
                </div>
            </div>
          ))}

        </div>
        <div className='w-full absolute top-[30%] bg-[#F7AB0A]/10 left-0 h-[500px] -skew-y-12'>

        </div>
    </div>
  )
}

export default Projects